/* eslint-disable no-console */
export async function useGetDemand(req: { id: any }) {
  try {
    const client = useLoansClient()
    const res = await client({
      method: 'GET',
      url: '/v2/Demands',
      params: {
        id: req.id,
      },
    })
    if (res.status >= 400) console.log('res', res)
    return {
      data: res.data,
      status: res.status,
    }
  }
  catch (e: any) {
    console.log('errors', e)
    return {
      status: e.response.status,
      statusText: e.message,
    }
  }
}
